import { configure, extend } from "vee-validate";
import {
    confirmed,
    double,
    email,
    length,
    max,
    max_value,
    min,
    min_value,
    numeric,
    required,
    required_if,
    oneOf,
    digits
} from "vee-validate/dist/rules";
import i18n from "./i18n";

extend("required", required);
extend("email", email);
extend("confirmed", confirmed);
extend("length", length);
extend("required_if", required_if);
extend("numeric", numeric);
extend("double", double);
extend("min", min);
extend("min_value", min_value);
extend("max", max);
extend("max_value", max_value);
extend("oneOf", oneOf);
extend("digits",digits)
extend("date_format", {
    validate(value, { format = "datetime-local" } = {}) {
        if (!value) return true;

        if (format === "datetime-local") {
            return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value);
        }
        if (format === "date") {
            return /^\d{4}-\d{2}-\d{2}$/.test(value);
        }
        return false;
    },
    params: ["format"],
});
extend('bau_email',{
    validate(value) {
        const email =value.toLowerCase();
        const regex = /@(std\.)?bahcesehir\.edu\.tr$/;
        return regex.test(email);
    },
    message: i18n.t('bau_email_rules_message')
})
extend("dynamic_between", {
    params:['min','max'],
    validate:(value, { min, max })=> {
        const numericValue=Number(value);
        const minValue=Number(min);
        const maxValue=Number(max);
        return !isNaN(numericValue) &&  numericValue>=minValue && numericValue<=maxValue
    },
    message:(fieldName, values)=> {
        return i18n.t(`validation.messages.${values._rule_}`,{
            min:values.min,
            max:values.max,
        });
    }

})

configure({
    defaultMessage: (field, values) => {
        return i18n.t(`validation.messages.${values._rule_}`, values);
    },
});
